export const isCompositionTabAvailable = location => {
    const validResourceTypes = [0, 1, 8, 10, 13, 12, 14, 15]
    return location && typeof location.resourceType === 'number' && validResourceTypes.includes(location.resourceType)
}
